<template>
  <div id="app" translate="no">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'app',
  created() {
    var v = this
    this.$http.interceptors.response.use(undefined, function (error) {
      return new Promise(function () {
        if (
          error.response.status === 401 &&
          error.config &&
          !error.config.__isRetryRequest
        ) {
          v.toLogin()
        }
        throw error
      })
    })
  },
  mounted() {
    this.setLang()
  },
  methods: {
    setLang() {
      this.$vuetify.lang.current = this.getLang
    },
    toLogin() {
      this.$store.dispatch('login/forceLogout')
      this.$router.push('/login')
    },
  },
  watch: {
    getLang() {
      this.setLang()
    },
    getUser() {
      // if (process.env.NODE_ENV !== 'production') return
      // window.HyperDX.init({
      //   apiKey: 'e24cb15e-78fa-45fa-b6a0-91d6426102c0',
      //   service: 'admin-skolable',
      // })
      // HyperDX.setGlobalAttributes({
      //   userId: `${this.getUser.id}`,
      //   userEmail: `${this.getUser.email}`,
      //   userName: `${this.getUser.email}`,
      //   college: `${this.getUser.branch.name}`,
      //   teamName: 'admin-skolable',
      // })
    },
  },
  computed: {
    ...mapGetters(['getLang', 'getUser']),
  },
}
</script>

<style>
.v-menu__content {
  border-radius: 23px !important;
}
html {
  font-family: Roboto;
}
.v-table__overflow {
  overflow-y: auto;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.v-table__overflow::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px #cccc;
  background-color: #cccc;
  border-radius: 10px;
}
.v-table__overflow::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background-color: #512e6f;
  display: block;
  opacity: 1;
}
.v-table__overflow::-webkit-scrollbar-thumb {
  background-color: #512e6f;
  border-radius: 10px;
  background-image: -webkit-linear-gradient(
    180deg,
    #ef565c 0%,
    #ef565c 25%,
    transparent 100%,
    #ef565c 75%,
    transparent
  );
}
.scrollDesign {
  overflow-y: auto;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-color: rgba(239, 86, 91, 1) !important;
  scrollbar-color: -moz-linear-gradient(
    left,
    rgba(239, 86, 91, 1) 0%,
    rgba(81, 46, 111, 1) 100%
  ) !important;
  scrollbar-color: -webkit-gradient(
    left top,
    right top,
    color-stop(0%, rgba(239, 86, 91, 1)),
    color-stop(100%, rgba(81, 46, 111, 1))
  ) !important;
  scrollbar-color: -webkit-linear-gradient(
    left,
    rgba(239, 86, 91, 1) 0%,
    rgba(81, 46, 111, 1) 100%
  ) !important;
  scrollbar-color: -o-linear-gradient(
    left,
    rgba(239, 86, 91, 1) 0%,
    rgba(81, 46, 111, 1) 100%
  ) !important;
  scrollbar-color: -ms-linear-gradient(
    left,
    rgba(239, 86, 91, 1) 0%,
    rgba(81, 46, 111, 1) 100%
  ) !important;
  scrollbar-color: linear-gradient(
    to right,
    rgba(239, 86, 91, 1) 0%,
    rgba(81, 46, 111, 1) 100%
  ) !important;
  scrollbar-width: thin;
}
.scrollDesign::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px #cccc;
  box-shadow: inset 0 0 6px #cccc;
  background-color: #cccc;
  border-radius: 10px;
}
.scrollDesign::-webkit-scrollbar {
  width: 10px;
  background-color: #512e6f;
  display: block;
  opacity: 1;
}
.scrollDesign::-webkit-scrollbar-thumb {
  background-color: #512e6f;
  border-radius: 10px;
  background-image: -webkit-linear-gradient(
    90deg,
    #ef565c 0%,
    #ef565c 25%,
    transparent 100%,
    #ef565c 75%,
    transparent
  );
}
.gradiente {
  background: rgba(239, 86, 91, 1) !important;
  background: -moz-linear-gradient(
    left,
    rgba(239, 86, 91, 1) 0%,
    rgba(81, 46, 111, 1) 100%
  ) !important;
  background: -webkit-gradient(
    left top,
    right top,
    color-stop(0%, rgba(239, 86, 91, 1)),
    color-stop(100%, rgba(81, 46, 111, 1))
  ) !important;
  background: -webkit-linear-gradient(
    left,
    rgba(239, 86, 91, 1) 0%,
    rgba(81, 46, 111, 1) 100%
  ) !important;
  background: -o-linear-gradient(
    left,
    rgba(239, 86, 91, 1) 0%,
    rgba(81, 46, 111, 1) 100%
  ) !important;
  background: -ms-linear-gradient(
    left,
    rgba(239, 86, 91, 1) 0%,
    rgba(81, 46, 111, 1) 100%
  ) !important;
  background: linear-gradient(
    to right,
    rgba(239, 86, 91, 1) 0%,
    rgba(81, 46, 111, 1) 100%
  ) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ef565b', endColorstr='#512e6f', GradientType=1) !important;
}

.gradiente-m {
  margin-right: 10px;
  background: rgba(239, 86, 91, 1) !important;
  background: -moz-linear-gradient(
    left,
    rgba(239, 86, 91, 1) 0%,
    rgba(81, 46, 111, 1) 100%
  ) !important;
  background: -webkit-gradient(
    left top,
    right top,
    color-stop(0%, rgba(239, 86, 91, 1)),
    color-stop(100%, rgba(81, 46, 111, 1))
  ) !important;
  background: -webkit-linear-gradient(
    left,
    rgba(239, 86, 91, 1) 0%,
    rgba(81, 46, 111, 1) 100%
  ) !important;
  background: -o-linear-gradient(
    left,
    rgba(239, 86, 91, 1) 0%,
    rgba(81, 46, 111, 1) 100%
  ) !important;
  background: -ms-linear-gradient(
    left,
    rgba(239, 86, 91, 1) 0%,
    rgba(81, 46, 111, 1) 100%
  ) !important;
  background: linear-gradient(
    to right,
    rgba(239, 86, 91, 1) 0%,
    rgba(81, 46, 111, 1) 100%
  ) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ef565b', endColorstr='#512e6f', GradientType=1) !important;
}
#img_edit_notice_default .v-image__image--cover,
#img_edit_notice_default2 .v-image__image--cover {
  background-size: 40% auto;
}
.semi-small {
  font-size: 90%;
}

.m-round {
  border-radius: 50% !important;
}
.error--text .cancelled {
  color: #cc0000 !important;
}

.error--text .saved {
  color: #e69138 !important;
}

.error--text .programming {
  color: #3c78d8 !important;
}

.error--text .to_authorized {
  color: #f1c232 !important;
}

.error--text .refused {
  color: #cc0000 !important;
}

.error--text .release {
  color: #6aa84f !important;
}

.error--text .finish {
  color: #999999 !important;
}

.cancelled {
  color: #cc0000 !important;
}

.saved {
  color: #e69138 !important;
}

.programming {
  color: #3c78d8 !important;
}

.to_authorized {
  color: #f1c232 !important;
}

.refused {
  color: #cc0000 !important;
}

.release {
  color: #6aa84f !important;
}

.finish {
  color: #999999 !important;
}

.centerContent {
  display: flex;
  align-items: center;
  justify-content: center;
}

.over {
  cursor: pointer;
}
</style>
